<template>
    <form id="form-checkout" method="post">
        <select id="form-checkout__identificationType" style="display:none;"></select>
        <input type="text" id="form-checkout__identificationNumber" style="display:none;" autocomplete="off"/>

        <div class="mb-3">

            <div class="card rounded border-0 shadow">
                <div class="bg-light p-4 text-center rounded-top">
                    <h4 class="mb-0 card-title text-primary">Cartão de crédito</h4>
                </div>

                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label" for="form-checkout__cardholderName">Nome: <span
                                    class="text-danger">*</span></label>
                                <input name="name" id="form-checkout__cardholderName" type="text"
                                       class="form-control fw-bold" required=""
                                       placeholder="Ex. João M Farias">
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label" for="form-checkout__cardholderCpf">CPF do titular do cartão: <span
                                    class="text-danger">*</span></label>
                                <input id="form-checkout__cardholderCpf" type="text" inputmode="numeric"
                                       class="form-control fw-bold" required
                                       placeholder="000.000.000-00" maxlength="14"
                                       v-model="cardholderCpf" v-mask="'###.###.###-##'">
                                <small class="text-danger" v-if="cpfError">{{ cpfError }}</small>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label" for="form-checkout__cardholderEmail">E-mail: <span
                                    class="text-danger">*</span></label>
                                <input id="form-checkout__cardholderEmail" type="email"
                                       class="form-control fw-bold" required autocomplete="email"
                                       placeholder="email@exemplo.com" v-model="cardholderEmail">
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label" for="credit_card_number">
                                    Número do cartão: <span class="text-danger">*</span>
                                </label>
                                <input type="text" autocomplete="off" id="form-checkout__cardNumber"
                                       class="form-control fw-bold" v-mask="'#### #### #### ####'"
                                       required="" placeholder="0000 0000 0000 0000">
                            </div>
                        </div>
                        <div class="col-md-12" style="display: none">
                            <div class="mb-3">
                                <label class="form-label" for="form-checkout__issuer">
                                    Emissor: <span class="text-danger">*</span>
                                </label>
                                <select type="text" id="form-checkout__issuer"
                                        class="form-control fw-bold">
                                </select>
                            </div>
                        </div>
                      <div class="col-md-12">
                        <div class="mb-3">
                          <label class="form-label" for="credit_card_number">
                            Parcelas: <span class="text-danger">*</span>
                          </label>
                          <select id="form-checkout__installments" class="form-control fw-bold">
                            <option value="" disabled>Preencha os dados do cartão.</option>
                          </select>
                        </div>
                      </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label" for="credit_card_data_valid">Data de expiração: <span
                                    class="text-danger">*</span></label>
                                <input type="text" autocomplete="off" id="form-checkout__expirationDate"
                                       class="form-control fw-bold"
                                       required="" placeholder="MM/AAAA" v-mask="'##/####'">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label" for="credit_card_cvv">Código de segurança: <span
                                    class="text-danger">*</span></label>
                                <input type="text" autocomplete="off" id="form-checkout__securityCode"
                                       class="form-control fw-bold"
                                       required="" placeholder="CVV" v-mask="'###'">
                            </div>
                        </div>
                        <div class="col-md-12" v-if="schedule.availabilityTime.avail_online">
                            <br>
                            <div class="mb-3">
                                <div class="form-check">
                                    <label class="form-check-label" for="flexCheckDefault">
                                        Ao agendar você concorda com
                                        <a target="_blank" href="https://policies.ubbimed.com.br/term-telemedicine.php"
                                           class="text-primary">
                                            Termos da teleconsulta.
                                        </a>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <slot name="saveCardOptions"></slot>
                        </div>
                        <div class="col-md-12" v-if="formError">
                            <small class="text-danger">{{ formError }}</small>
                        </div>
                        <div class="col-md-12">
                            <div class="d-grid">
                                <button class="btn btn-primary" type="submit" id="form-checkout__submit">
                                    Agendar consulta
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>
</template>

<script>
import {mask} from "vue-the-mask";
import http from "../../../helpers/http";

export default {
    name: "CreditCardMP",
    directives: {
        mask,
    },
    props: {
        booking: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            msgErrorHashCreditCard: '',
            cardholderCpf: '',
            cardholderEmail: '',
            cpfError: '',
            formError: '',
        }
    },
    created() {
        const script = 'https://sdk.mercadopago.com/js/v2';
        if (!document.head.querySelector(`script[src="${script}"]`)) {
            const tag = document.createElement('script');
            tag.setAttribute('src', script);
            tag.setAttribute('type', 'text/javascript');
            document.head.appendChild(tag);
        }
    },
    async mounted() {
        this.cardholderEmail = (this.userAuth?.user_email || '').trim()
        const raw = (this.userAuth?.user_cpf || '').replace(/\D/g, '').slice(0, 11)
        if (raw.length === 11) {
            this.cardholderCpf = raw.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
        }
        this.$el.addEventListener('submit', this.syncCardholderIdentification, true)

        let response = await http.get('/card-administrators/MP/public-key', {
            params: {
                id_place: this.schedule.professional.id_place,
            }
        });
        let publicKey = response.data;

        await new Promise(r => setTimeout(r, 1000));
        const mp = new MercadoPago(publicKey);

        const cardForm = mp.cardForm({
            locale: 'pt-BR',
            amount: this.schedule.cancelingPolicy.value,
            iframe: false,
            form: {
                id: "form-checkout",
                cardNumber: {
                    id: "form-checkout__cardNumber",
                    placeholder: "Número do cartão",
                },
                expirationDate: {
                    id: "form-checkout__expirationDate",
                    placeholder: "MM/YY",
                },
                securityCode: {
                    id: "form-checkout__securityCode",
                    placeholder: "Código de segurança",
                },
                cardholderName: {
                    id: "form-checkout__cardholderName",
                    placeholder: "Titular do cartão",
                },
                issuer: {
                    id: "form-checkout__issuer",
                    placeholder: "Banco emissor",
                },
                installments: {
                    id: "form-checkout__installments",
                    placeholder: "Parcelas",
                },
                identificationType: {
                    id: "form-checkout__identificationType",
                    placeholder: "Tipo de documento",
                },
                identificationNumber: {
                    id: "form-checkout__identificationNumber",
                    placeholder: "Número do documento",
                },
                cardholderEmail: {
                    id: "form-checkout__cardholderEmail",
                    placeholder: "E-mail",
                },
            },
            callbacks: {
                onFormMounted: error => {
                    if (error) return console.warn('Form Mounted handling error: ', error)
                    const identification = document.getElementById('form-checkout__identificationType')
                    if (identification) {
                        this.identificationObserver = new MutationObserver(() => this.syncCardholderIdentification())
                        this.identificationObserver.observe(identification, { childList: true, subtree: true })
                    }
                    this.syncCardholderIdentification()
                },
                onSubmit: async (event) => {
                    event.preventDefault();
                    this.formError = ''
                    const digits = this.cardholderCpf.replace(/\D/g, '')
                    if (digits.length !== 11) {
                        this.cpfError = 'Informe o CPF do titular do cartão.'
                        return
                    }
                    this.cpfError = ''
                    const email = (this.cardholderEmail || '').trim()
                    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                        this.formError = 'Informe o e-mail do titular do cartão.'
                        return
                    }
                    this.syncCardholderIdentification()
                    const cardFormData = cardForm.getCardFormData();
                    if (!cardFormData?.token) {
                        this.formError = 'Não foi possível validar o cartão. Verifique os dados e tente novamente.'
                        return
                    }
                    if (!this.tokenMatchesHolder(cardFormData)) {
                        this.formError = 'Não foi possível validar o titular do cartão. Confira CPF e e-mail e tente novamente.'
                        return
                    }

                    const deviceId = await this.waitForDeviceId()
                    if (!deviceId) {
                        this.formError = 'Não foi possível validar o dispositivo. Atualize a página e tente novamente.'
                        return
                    }

                    this.$emit('onSubmit', {
                        issuer_id: cardFormData.issuerId,
                        payment_method_id: cardFormData.paymentMethodId,
                        token: cardFormData.token,
                        installments: cardFormData.installments,
                        device_id: deviceId,
                        payer_email: String(cardFormData.cardholderEmail || email).trim(),
                    });
                },
            },
        });
    },
    computed: {
        paymentMethod() {
            return this.schedule.paymentMethod;
        },
        schedule() {
            return this.booking || this.$store.state.toSchedule.schedule;
        },
        userAuth() {
            return this.$store.state.auth.user;
        },
        cardholderCpfDigits() {
            return (this.cardholderCpf || '').replace(/\D/g, '').slice(0, 11)
        },
    },
    watch: {
        cardholderCpf() {
            this.syncCardholderIdentification()
        },
        cardholderEmail() {
            this.syncCardholderIdentification()
        },
    },
    beforeUnmount() {
        this.$el?.removeEventListener('submit', this.syncCardholderIdentification, true)
        this.identificationObserver?.disconnect()
        this.identificationObserver = null
    },
    methods: {
        syncCardholderIdentification() {
            const input = document.getElementById('form-checkout__identificationNumber')
            const digits = this.cardholderCpfDigits
            if (input && input.value !== digits) {
                input.value = digits
                input.dispatchEvent(new Event('input', { bubbles: true }))
                input.dispatchEvent(new Event('change', { bubbles: true }))
            }

            const emailInput = document.getElementById('form-checkout__cardholderEmail')
            const email = (this.cardholderEmail || '').trim()
            if (emailInput && emailInput.value !== email) {
                emailInput.value = email
                emailInput.dispatchEvent(new Event('input', { bubbles: true }))
                emailInput.dispatchEvent(new Event('change', { bubbles: true }))
            }

            const select = document.getElementById('form-checkout__identificationType')
            const option = select ? [...select.options].find((item) => item.value.toUpperCase() === 'CPF') : null
            if (select && option && select.value !== option.value) {
                select.value = option.value
                select.dispatchEvent(new Event('change', { bubbles: true }))
            }
        },
        deviceIdValue() {
            const sessionId = (window.MP_DEVICE_SESSION_ID || '').trim()
            if (sessionId) {
                return sessionId
            }

            return (document.getElementById('deviceId')?.value || '').trim()
        },
        waitForDeviceId() {
            const current = this.deviceIdValue()
            if (current) {
                return Promise.resolve(current)
            }

            return new Promise((resolve) => {
                const started = Date.now()
                const timer = window.setInterval(() => {
                    const value = this.deviceIdValue()
                    if (value || Date.now() - started >= 2500) {
                        window.clearInterval(timer)
                        resolve(value)
                    }
                }, 100)
            })
        },
        tokenMatchesHolder(cardFormData) {
            const type = String(cardFormData?.identificationType || '').trim().toUpperCase()
            const number = String(cardFormData?.identificationNumber || '').replace(/\D/g, '')
            const email = String(cardFormData?.cardholderEmail || '').trim()
            const expectedEmail = (this.cardholderEmail || '').trim().toLowerCase()

            if (type && type !== 'CPF') {
                return false
            }
            if (number && number !== this.cardholderCpfDigits) {
                return false
            }
            if (email && email.toLowerCase() !== expectedEmail) {
                return false
            }

            return true
        },
    },
}
</script>

<style scoped>

</style>